/**
 *
 * DivisionEditTemplate
 *
 */

import React, { Fragment } from "react"
import { sortBy, uniqBy, find, flatMap, isEmpty } from "lodash"
import { Button, Form, Input, Tooltip, message } from "antd"

import SelectorHR from "components/Select"
import ListSubdivisions from "../ListSubdivisions"
import ModalAmbassadorDelete from "../ModalAmbassadorDelete"
import Record from "../Record"
import AddSubdivisionSelect from "../AddSubdivisionSelect"
import AddAmbassadorSelect from "../AddAmbassadorSelect"
import ModalCustom from "../ModalCustom"
import deleteSvg from "../../images/delete.svg"
import alertSvg from "../../images/alert.svg"

import { LeftOutlined } from "@ant-design/icons"
import "./index.less"
import { isModuleBySlug } from "../../utils/storage"
import { AMBASSADOR_USERS } from "../../utils/constants"

const FormItem = Form.Item

/* eslint-disable react/prefer-stateless-function */
class DivisionEditTemplate extends React.Component {
  state = {
    modalOpen: false,
    modalDelete: false,
    modalDeleteSubdivision: false,
    modalChangeDivisionSuperior: false,
    modalBackDivisions: false,
    nameDivision: "",
    divisionParentSelected: undefined,
    valueOptionSelected: undefined,
    subdivisionDeleted: undefined,
    showFieldRequired: false,
    showButtonSaveName: false,
    selectedEmployee: undefined,
    modalAmbassadorDelete: false,
    currentAmbassador: {},
  }

  setStateFromProps = () => {
    const {
      division,
      division: { name, divisionparents },
    } = this.props

    let valueOfDivisionParent

    if (!division.autoassigned) {
      valueOfDivisionParent = divisionparents[0]
        ? divisionparents[0].id_division
        : undefined
    }

    this.setState({
      nameDivision: name,
      divisionParentSelected: valueOfDivisionParent,
    })
  }

  componentDidMount = () => {
    this.setStateFromProps()
  }

  subdivisionDeleted = null

  showAlertDeleteSubdivision = () => {
    setTimeout(() => {
      if (this.props.messageDeleteSubdivision) {
        message.success(
          <span>
            {this.props.messageDeleteSubdivision.msj}{" "}
            <span
              style={{ color: "#2694FC", cursor: "pointer" }}
              onClick={() => {
                const params = {
                  idDivision: this.props.division.id_division,
                  idSubdivision: this.subdivisionDeleted.id_division,
                }
                this.props.addSubdivision(params)
                message.destroy()
              }}>
              Deshacer
            </span>
          </span>,
          2.5
        )
      }
    }, 1500)
  }

  toggleModal = (value) => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  changeSelectOption = (name, value) => {
    if (name === "divisionParentSelected") {
      return this.setState({
        modalChangeDivisionSuperior: true,
        [name]: value,
      })
    }

    this.setState({ [name]: value })
  }

  changeTextInput = (name, value) => {
    if (name === "nameDivision") {
      this.setState({
        showFieldRequired: false,
        showButtonSaveName: true,
      })
    }
    this.setState({ [name]: value })
  }

  onSaveName = () => {
    if (!this.state.nameDivision) {
      return this.setState({ showFieldRequired: true })
    }
    this.setState({
      showButtonSaveName: false,
      nameDivision: this.state.nameDivision.trim(),
    })
    const params = {
      idDivision: this.props.division.id_division,
      nameDivision: this.state.nameDivision.trim(),
    }

    this.props.updateNameDivision(params)
  }

  render() {
    const { modalAmbassadorDelete, currentAmbassador } = this.state
    const {
      subdivisionsWithoutParent,
      childrenDivision,
      divisionParents,
      division: { id_division, level },
    } = this.props

    let filterChildrenDivisionLevelOne = childrenDivision.divisionchildren || []

    if (level === 1) {
      filterChildrenDivisionLevelOne = filterChildrenDivisionLevelOne.filter(
        (item) => !item.autoassigned
      )
    }

    const idDivisionAmbassador = flatMap(
      this.props.division.ambassadors,
      (item) => item.id_employee
    )
    const listAmbassadorsToAdd = this.props.list_employees.filter(
      (d) => !idDivisionAmbassador.includes(d.id_employee)
    )
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    return (
      <div style={{ backgroundColor: "#F9F9F9" }}>
        <div className="divisionHeader">
          <div className="divisionTitle">
            <div
              className="btnBack"
              onClick={() => {
                if (
                  !(
                    (!(this.state.nameDivision === this.props.division.name) &&
                      this.state.showButtonSaveName) ||
                    this.state.nameDivision.length >= 150
                  )
                ) {
                  return this.props.history.push("/organization/divisions")
                }

                this.setState({ modalBackDivisions: true })
              }}>
              <LeftOutlined />
              Divisiones
            </div>
            <span style={{ fontWeight: 600 }}>
              {this.props.division.name || ""}
            </span>
          </div>
          <div>
            <Button
              onClick={() => this.setState({ modalDelete: true })}
              className="btnDelete">
              <img src={deleteSvg} />
              Eliminar
            </Button>
          </div>
        </div>
        <div className="divisionBody">
          <div className="sectionEdit">
            <div>
              <Form layout="vertical" className="sectionForm">
                <div className="sectionEdit-column">
                  <FormItem
                    className="nameSectionForm"
                    required
                    label={<span style={{ fontWeight: 600 }}>Nombre</span>}>
                    {this.state.showFieldRequired && (
                      <span className="fieldRequired">Campo obligatorio</span>
                    )}
                    <Input
                      value={this.state.nameDivision}
                      className="inputText"
                      maxLength={150}
                      onPressEnter={this.onSaveName}
                      onChange={(event) => {
                        this.changeTextInput("nameDivision", event.target.value)
                      }}
                    />
                  </FormItem>
                  {((!(this.state.nameDivision === this.props.division.name) &&
                    this.state.showButtonSaveName) ||
                    this.state.nameDivision.length >= 151) && (
                    <div className="sectionEdit-column-right">
                      <Button
                        type="primary"
                        style={{ marginRight: 8 }}
                        onClick={this.onSaveName}>
                        Guardar
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({
                            nameDivision: this.props.division.name,
                          })
                        }}>
                        Cancelar
                      </Button>
                    </div>
                  )}
                </div>

                <FormItem
                  label={
                    <span style={{ fontWeight: 600 }}>División superior</span>
                  }>
                  <SelectorHR
                    placeholder="Seleccionar división superior"
                    options={uniqBy(divisionParents, "id_division")}
                    labelKey="id_division"
                    label="name"
                    value={this.state.divisionParentSelected}
                    allowClear
                    onChange={(e) => {
                      const idParent = e ? e.id_division : undefined
                      const params = {
                        idDivision: this.props.division.id_division,
                        idParent:
                          typeof idParent === "undefined"
                            ? "sin-asignar"
                            : idParent,
                      }
                      this.props.changeSelectSuperior(params)
                    }}
                    style={{ width: 415 }}
                  />
                </FormItem>

                <div
                  className="sectionEdit-column"
                  style={{ alignItems: "initial" }}>
                  <FormItem
                    label={
                      <div
                        style={{
                          width: 415,
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "space-between",
                        }}>
                        <div style={{ fontWeight: 600 }}>
                          Subdivisiones
                          <span
                            className="color-gray-medium"
                            style={{ fontWeight: 400 }}>
                            &nbsp;(
                            {filterChildrenDivisionLevelOne
                              ? filterChildrenDivisionLevelOne.length
                              : 0}
                            )
                          </span>
                        </div>
                      </div>
                    }>
                    <ListSubdivisions
                      loading={this.props.isLoadingChildrenDivision}
                      data={sortBy(filterChildrenDivisionLevelOne, "name")}
                      onRemove={(subdivisionSelected) => {
                        this.setState({
                          subdivisionDeleted: subdivisionSelected,
                          modalDeleteSubdivision: true,
                        })
                        this.subdivisionDeleted = subdivisionSelected
                      }}
                    />
                  </FormItem>

                  <div
                    className="sectionEdit-column-right"
                    style={{ marginTop: 32 }}>
                    <AddSubdivisionSelect
                      changeSelectOption={this.changeSelectOption}
                      data={subdivisionsWithoutParent.filter(
                        (item) =>
                          item.id_division !== this.state.divisionParentSelected
                      )}
                      isButtonDisabled={!this.state.valueOptionSelected}
                      valueOptionSelected={this.state.valueOptionSelected}
                      onAdd={() => {
                        const params = {
                          idDivision: id_division,
                          idSubdivision: this.state.valueOptionSelected,
                        }

                        this.props.addSubdivision(params)
                        this.setState({ valueOptionSelected: undefined })
                      }}
                    />
                  </div>
                </div>

                {isAmbassador && (
                  <Fragment>
                    <div>
                      <FormItem
                        style={{ margin: "0 0 -10px", padding: 0 }}
                        label={
                          <div>
                            <div style={{ fontWeight: 600 }}>
                              Embajador de Clima Laboral y Engagement
                              <span
                                className="color-gray-medium"
                                style={{ fontWeight: 400 }}>
                                &nbsp;(
                                {this.props.division.ambassadors.length})
                              </span>
                            </div>
                            <p
                              style={{
                                fontWeight: 400,
                                marginTop: 10,
                                marginBottom: 0,
                                textAlign: "justify",
                              }}>
                              Los usuarios asignados como <b>embajadores </b>
                              estarán a cargo de ejecutar planes de acción con
                              el objetivo de mejorar el{" "}
                              <span className="bold">Clima&nbsp;Laboral</span>
                              &nbsp;y&nbsp;
                              <span className="bold">Engagement</span> de la
                              división a la que son asignados. Tendrán
                              visibilidad de los resultados de su división, y
                              las divisiones debajo. <br /> Es posible asignar
                              más de un embajador por división, y más de una
                              división por embajador.
                            </p>
                          </div>
                        }
                      />
                    </div>
                    <div
                      className="sectionEdit-column"
                      style={{ alignItems: "initial" }}>
                      <FormItem>
                        <ListSubdivisions
                          onRemove={(e) => {
                            e.id_division = this.props.division.id_division
                            e.divisions = [{ name: this.props.division.name }]
                            this.setState({
                              currentAmbassador: e,
                              modalAmbassadorDelete: true,
                            })
                          }}
                          label="full_name"
                          loading={false}
                          data={this.props.division.ambassadors}
                        />
                      </FormItem>

                      <div
                        className="sectionEdit-column-right"
                        style={{ marginTop: 3 }}>
                        <AddAmbassadorSelect
                          selectedDivision={this.props.division}
                          changeSelectOption={this.changeSelectOption}
                          data={listAmbassadorsToAdd}
                          isButtonDisabled={!this.state.selectedEmployee}
                          valueOptionSelected={this.state.selectedEmployee}
                          updateAmbassadors={(e) => {
                            this.props.division.ambassadors.push(e)
                            this.forceUpdate()
                          }}
                          isLoadingLanguage={this.props.isLoadingLanguage}
                          languages={this.props.languages}
                          getLanguage={this.props.getLanguage}
                        />
                      </div>
                    </div>
                  </Fragment>
                )}
              </Form>
            </div>
            {!isEmpty(this.props.dataHistory) && (
              <div className="historial">
                <span>Historial</span>
                <Record dataHistory={this.props.dataHistory} />
              </div>
            )}
          </div>
        </div>
        {/* orgnigrama */}
        {/* <div className='organigrama'>
          <span style={{fontWeight: 'bold', color: '#4F4F4F', fontSize: 14 }}>Ubicación en el orgnigrama</span>
          <div className='orgnigramaContainer'>
            <img src={rowsSvg}/>
            <p>Arrastra la división para cambiar su ubicación en el organigrama</p>
            <Button type='primary'>Aceptar</Button>
          </div>
        </div> */}

        {/* engagement */}
        {/* <div className='engagement'>
          <span style={{fontWeight: 'bold', color: '#4F4F4F', fontSize: 14 }}>Resultados de Engagement</span>
        </div> */}

        <ModalCustom
          showFooter
          onCancel={this.toggleModal}
          modalOpen={this.state.modalOpen}
          onOk={() => {
            this.props.upLevelOne(id_division)
            this.toggleModal()
          }}>
          <img src={alertSvg} className="alertIcon" />
          <p>
            ¿Estás seguro de que deseas seleccionar a{" "}
            <span style={{ fontWeight: 600 }}>{this.state.nameDivision}</span>{" "}
            como la división de mayor jerarquía?
          </p>
          <p>
            Esta reemplazará a{" "}
            <span style={{ fontWeight: 600 }}>
              {find(this.props.divisionParents, { level: 1 })
                ? find(this.props.divisionParents, { level: 1 }).name
                : ""}
            </span>{" "}
            como división de Nivel 1 en el organigrama de la empresa.
          </p>
        </ModalCustom>
        <ModalCustom
          disabledButton={this.props.collaboratorsDivision.length}
          showFooter
          modalOpen={this.state.modalDelete}
          textButton="Eliminar"
          colorButton="#EA6364"
          onCancel={() => this.setState({ modalDelete: false })}
          onOk={() => {
            this.props.deleteDivision(this.props.division.id_division)
            this.setState({ modalDelete: false })
          }}>
          <img src={alertSvg} className="alertIcon" alt="alert-svg" />
          {Array.isArray(this.props.collaboratorsDivision) &&
          this.props.collaboratorsDivision.length ? (
            <p>
              No es posible eliminar una división con colaboradores asignados.
            </p>
          ) : (
            <React.Fragment>
              <span style={{ fontWeight: 600, fontSize: 14 }}>
                ¿Estás seguro de que deseas eliminar la división seleccionada?{" "}
              </span>
              <p>
                Deberás asignarle una nueva división superior a las
                subdivisiones dentro.
              </p>
            </React.Fragment>
          )}
        </ModalCustom>
        <ModalCustom
          showFooter
          modalOpen={this.state.modalDeleteSubdivision}
          onCancel={() => this.setState({ modalDeleteSubdivision: false })}
          onOk={() => {
            const params = {
              idSubdivision: this.state.subdivisionDeleted.id_division,
              idDivision: this.props.division.id_division,
            }
            this.props.deleteSubdivision(params)
            this.showAlertDeleteSubdivision()
            this.setState({
              modalDeleteSubdivision: false,
              subdivisionDeleted: undefined,
            })
          }}>
          <img src={alertSvg} className="alertIcon" />
          <p>
            ¿Estás seguro de que deseas eliminar a{" "}
            <span style={{ fontWeight: 600 }}>
              {this.state.subdivisionDeleted
                ? this.state.subdivisionDeleted.name
                : ""}{" "}
            </span>
            como subdivisión de{" "}
            <span style={{ fontWeight: 600 }}>{this.props.division.name}</span>?
          </p>
        </ModalCustom>
        {/* <ModalCustom
          showFooter
          modalOpen={this.state.modalChangeDivisionSuperior}
          onCancel={() => this.setState({
            modalChangeDivisionSuperior: false,
          }, () => {
            this.setState({
              divisionParentSelected: this.props.division.divisionparents.length ? this.props.division.divisionparents[0].id_division : undefined
            })
          })}
          onOk={() => {
            const params = {
              idDivision: this.props.division.id_division,
              idParent: this.state.divisionParentSelected
            }
            this.props.changeSelectSuperior(params);
            this.setState({
              modalChangeDivisionSuperior: false,
            })
          }}
        >
          <img src={alertSvg} className="alertIcon"/>
          <span>¿Estás seguro de que deseas cambiar la división superior a <span style={{ fontWeight: 600 }}>{get(find(this.props.divisionParents, { 'id_division': this.state.divisionParentSelected }), 'name', 'Sin Asignar')}</span>?</span>
          <p>Recuerda que esto tendrá implicancias en el organigrama de la organización.</p>
        </ModalCustom> */}

        <ModalCustom
          showFooter
          modalOpen={this.state.modalBackDivisions}
          onCancel={() => this.setState({ modalBackDivisions: false })}
          onOk={() => this.props.history.push("/organization/divisions")}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas salir sin guardar los cambios?
          </span>
          <p style={{ fontSize: 13 }}>
            La información no será registrada y deberás iniciar un nuevo
            proceso.
          </p>
        </ModalCustom>

        <ModalAmbassadorDelete
          currentAmbassador={currentAmbassador}
          deleteByDivision
          open={modalAmbassadorDelete}
          onCancel={() => this.setState({ modalAmbassadorDelete: false })}
          onFinish={() => {
            const findIndexToDelete = this.props.division.ambassadors.findIndex(
              (e) => e.id_ambassador === currentAmbassador.id_ambassador
            )
            if (findIndexToDelete > -1) {
              this.props.division.ambassadors.splice(findIndexToDelete, 1)
            }
            this.forceUpdate()
            this.setState({ modalAmbassadorDelete: false })
          }}
        />
      </div>
    )
  }
}

DivisionEditTemplate.propTypes = {}

export default DivisionEditTemplate
